    
<template>
  <div>
    <p style="text-align: center;">Authentication successful. Please wait.</p>
  </div>
</template>
<script>
import { setIdToken, setAccessToken } from "../services/authentication";
export default {
  name: "",
  components: {},
  mounted() {
    setAccessToken();
    setIdToken();
    window.location.href = "/";
  }
};
</script>